import {useCallback, useEffect, useState} from 'react';

import { getChat } from '../../utils/api';

import Header from '../header/Header';
import Transcript from '../transcript/Transcript';

import './Chat.css';

function Chat({ handleError, handleFeedback, handlePath, handleStartOver }) {
  const [messages, setMessages] = useState(null);

  const loadMessages = useCallback(async () => {
    try {
      setMessages(await getChat());
    } catch (e) {
      handleError(e);
    }
  }, [handleError]);

  useEffect(() => {
    loadMessages();
  }, [loadMessages]);

  return (
    <>
      <Header handleFeedback={handleFeedback} handlePath={handlePath} handleStartOver={handleStartOver} />
      <div id="chat" className="clamp">
        <Transcript activity={false} handleError={handleError} handlePath={handlePath} isProfile={false} transcript={messages} />
      </div>
    </>
  );
}

export default Chat;
